const acronyms = [
  'Uri\'s Recursive Identity',
  'Undefined Route Index',
  'Unholy, Rebel, Insatiable',
  'Uniform Resource Identifier',
  'United Religions Initiative',
  'Universal Resource Identifier',
  'University of Rhode Island',
  'Unknown Routes Incoming',
  'Unless Reactions Improve',
  'Unmatched Random Intelligence',
  'Unquoted Reference Introduced',
  'Unspoken Rivalry Inbetween',
  'Unstable Radioactive Isotope',
  'Units of Raw Intensity',
  'Until Rodents Increase',
  'Utmost Religious Importance',
  'Upper Respiratory Infection',
  'Useful Resource, Indeed',
  'Useful Rapid Inventions',
  'Useful Reusable Interfaces',
  'Useless Research Institute',
  'Using Reckless Ideas',
  'Using Ruby Indefinitely',
  'Unidad de Replicación de Inteligencia'
]

export default acronyms;
